<template>
  <div
    ref="header"
    :class="{ 'tw:bg-white/70 tw:backdrop-blur-xs tw:shadow-xs': isScrolled }"
    aria-label="main navigation"
    class="tw:fixed tw:w-full tw:px-4 tw:md:px-6 tw:py-4 tw:flex tw:items-center tw:justify-between tw:z-20 tw:transition-all tw:duration-300"
    role="banner"
  >
    <a aria-label="edrone homepage" href="https://edrone.me/">
      <img
        alt="Logo edrone"
        class="tw:h-full tw:max-w-20 tw:w-full"
        loading="eager"
        src="https://d3vhsxl1pwzf0p.cloudfront.net/images_2_6/v2/logo.svg"
      />
    </a>
    <div class="tw:flex tw:items-center tw:gap-4">
      <a class="tw:hidden tw:md:inline-block" href="/login">
        <EdroneButton type="text">{{ trans._register.login }}</EdroneButton>
      </a>
      <EdroneSelectCustom
        :allow-empty="false"
        :options="languageOptions"
        :selected-options="languageOptions.find((option) => option.value === language)"
        aria-label="Choose language"
        class="tw:w-[9.375rem]"
        @select="handleLanguageChange"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted } from "vue";
import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";
import EdroneButton from "edrone-components/EdroneButton.vue";
import EdroneSelectCustom from "edrone-components/EdroneSelectCustom.vue";
import { useRegisterStore } from "vue-app-new/modules/Register/store/Register.store";
import { amplitudeSendEvent } from "vue-app/utils/amplitude";
import { setCookie } from "vue-app/utils/cookies";

const router = useRouter();
const store = useRegisterStore();
const { language, email, shopUrl } = storeToRefs(store);

const header = ref<HTMLElement>();
const isScrolled = ref(false);

const handleScroll = () => {
  isScrolled.value = window.scrollY > 10;
};

const languageOptions = [
  { value: "pl", name: "Polski" },
  { value: "en", name: "English" },
  { value: "pt", name: "Português" },
  { value: "es", name: "Español" },
];

const handleLanguageChange = (option: { value: string; name: string } | undefined) => {
  if (!option) return;

  const previousLanguage = language.value;
  language.value = option.value;

  amplitudeSendEvent("register_language_changed", {
    previous_language: previousLanguage,
    new_language: option.value,
    step: "form",
  });

  setCookie("preferred_language", option.value);

  const newUrl = new URL(window.location.href);
  newUrl.searchParams.set("lang", option.value);
  window.location.href = newUrl.toString();
};

onMounted(() => {
  window.addEventListener("scroll", handleScroll);

  setTimeout(() => {
    const query = router.currentRoute.value.query;

    language.value = window.preferredLanguage;

    if (query.email) {
      email.value = query.email.toString();
    }
    if (query.shopUrl) {
      shopUrl.value = query.shopUrl.toString();
    }
  }, 1);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>
